export interface TicketDetails {
  identifier?: string;
  objectId?: number;
  urn?: string;
  spaceName?: string;
  spaceUrn?: string;
  spaceObjectId?: number;
  summary?: string;
  description?: string;
  created_on?: string;
  request?: string;
  priority?: string;
  severity?: string;
  status?: string;
  communication?: string;
  assigned_to?: string;
  remarks?: string;
  created_by?: string;
  number?: string;
  department?: string;
}
